//#region src/engine/modules/index-column/actions.ts
var ActionType = {
	addIndexColumn: "indexColumn.add",
	removeIndexColumn: "indexColumn.remove",
	moveIndexColumn: "indexColumn.move",
	changeIndexColumnOrderType: "indexColumn.changeOrderType"
};
//#endregion
export { ActionType };
